export function menuList1 (fontsize){
    return {
        "menu":[
            {
                "name":"收藏至股市日记",
                "msg":"collect",
                "type":0,
                "notify":0
            },{
                "name":"字体大小",
                "value":[
                    {
                        "name":"大",
                        "msg":"fontsize=large"
                    },{
                        "name":"小",
                        "msg":"fontsize=medium"
                    }
                ],
                "select": fontsize == 'large' ? '大' : '小',
                "type":1,
                "notify":1
            }
        ]
    }
}
